/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */
// library imports
import { Component, createRef } from 'react';
import { Button, Form, Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import axios from 'axios';
import DatePicker from "react-datepicker";
import moment from 'moment';
// project imports
import { getSellerUrl, getSellerHeaders } from 'shared/http';
import { sellerReport, locationlist } from 'shared/settings/apiconfig';
import Datatable from 'shared/datatable';
import { ArrayValueReorder } from 'shared/modifiers';
// style imports
import "react-datepicker/dist/react-datepicker.css";
import './Admin.scss';
/**
 * this page is used to show seller report in table
 * 
 * @param props
 * 
 * @return  sales report html code
 * 
**/
export default class SellerReport extends Component {
    initialSearchState;
    search;
    startDatePicker;
    endDatePicker;
    config;
    id;
    filterSearch;
    constructor(props) {
        super(props);
        this.dataTable = createRef();
        /* initial search state */
        this.initialSearchState = {
            starttime:{ field: 'fromdate', value: '', op: '>=', join: 'AND'},
            endtime: { field: 'todate', value: '', op: '<=', join: 'AND' },
            locationid: { field: 'locationid', value: '', op: '=', join: 'AND' },
        }
        this.state = {
            search: this.initialSearchState,
            searchData: false,
            modal: false,
            tableData: [],
            salesDetails: {},
            category: [],
            sales: [],
            issearch: false,
            saleid: { value: '', valid: false, error: '' },
            locations: [],
            isdisabled: false,
            location: '',
            locationlength:0,
            isActiveCheckbox : "",
            isDateFromCheckBox: "",
            DateCheckBoXValue: '',
            currentDate : '',
            SearchButton : false,
            locationAllSelected: false
        }
        this.config = {
            name: 'seller report',
            url: sellerReport,
            isReport: true,
            params: {},
            columns: [
                { name: 'Location Name', property: 'loc_title', sort: false, width: '200px', columnType: 'custom', customColumn: this.locationName, toolTip: true, toolTipText: 'Location Name' },
                { name: 'Number of Sales Closed', property: 'saleCount', sort: false, width: '200px', columnType: 'custom', customColumn: this.saleCount, toolTip: true, toolTipText: 'Number of Sales Closed : the locations amount of closed sales within the given date range ' },
                { name: 'Number of Items Sold', property: 'itemSoldCount', sort: false, width: '200px',columnType: 'custom', customColumn: this.itemSoldCount, toolTip: true, toolTipText: 'Number of Items Sold : the locations number of items that have been sold within the given date range' },
                { name: 'Number of Items Not Sold', sort: false, width: '200px',columnType: 'custom', customColumn: this.itemNotSoldCount, toolTip: true, toolTipText: 'Number of Items Not Sold : the locations number of items that were not sold within the given date range' },
                { name: "Total Sale Price + Buyer's Premium", property: 'price', sort: false, width: '250px', columnType: 'custom', customColumn: (row) => { if ('price' in row && row.price !== null) {return (`$${parseFloat(row.price).toFixed(2)}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","))} else {return 0} }, toolTip: true , toolTipText: "Total Sale Price + BP : the sum of sale price + BP for all the sales for the location in the given date range" },
                {
                    name: '', property: 'id', columnType: 'actions', actions: [], customHeader: "CSV", width: '200px',
                }
            ],
            pagination: true,
            filename: "seller-report",
            csvColumn: [
                { name: 'Location Name', property: 'loc_title', },
                { name: 'Number of Sales Closed', property: 'saleCount', columnType: 'custom', customColumn: this.saleCount },
                { name: 'Number of Items Sold', property: 'itemSoldCount', columnType: 'custom', customColumn: this.itemSoldCount },
                { name: 'Number of Items Not Sold',property: 'itemNotSoldCount', columnType: 'custom', customColumn: this.itemNotSoldCount},
                { name: "Total Sale Price + Buyer's Premium", property: 'price', columnType: 'custom', customColumn: (row) => { if ('price' in row && row.price !== null) {return (`$${parseFloat(row.price).toFixed(2)}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","))} else {return 0} } },
            ]    
        };
        this.search = {};
        this.startDatePicker = false;
        this.endDatePicker = false;
        this.id = null;
        this.locations = [];
    }
    componentDidMount = () => {
        this.getLocationList();
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', this.onBack);
    }
    onBack = (e) => {
        e.preventDefault();
        window.history.pushState(null, null, window.location.pathname);
    }
    
    // Total itemNotSoldCount
    itemNotSoldCount = (value) => {
        const res = value.itemNotSoldCount ? value.itemNotSoldCount : "0"
        return res;
    }
    // Total itemSoldCount custom column
    itemSoldCount = (value) => {
        const res = value.itemSoldCount ? value.itemSoldCount : '0'
        return res
    }
    // Total saleCount
    saleCount = (value) => {
        const res = value.saleCount ? value.saleCount : '0'
        return res
    }
    // locationName custom column
    locationName = (value) => {
        const res = value.loc_title ? value.loc_title : '- - -'
        return res
    }
    setEndDate() {
        let end_date = moment().subtract(1, "days").endOf('day').format("YYYY-MM-DD HH:mm:ss");
        this.setState({
            currentDate : end_date
        },()=>{
            this.searchEnable()
        })
    }
    
    onChangeCheckBox = (event,date) => {
        if(event === this.state.isActiveCheckbox){
            this.setState({
                isActiveCheckbox: '',
                isDateFromCheckBox: false,
                DateCheckBoXValue: '',
            })
        }
        else{
            this.setState({
                isActiveCheckbox: event,
                isDateFromCheckBox: true,
                DateCheckBoXValue: date,
            },()=>{
                this.setState({
                    ...this.state,
                    issearch: true,
                    search: {
                        ...this.state.search,
                        starttime: {
                            ...this.state.search['starttime'],
                            value: ''
                        },
                        endtime: {
                            ...this.state.search['endtime'],
                            value: ''
                        },
                      /*   ['starttime']: {
                            ...this.state.search['starttime'],
                            value: ''
                        },
                        ['endtime']: {
                            ...this.state.search['endtime'],
                            value: ''
                        }, */
                    }
                })
            })  
        }
        this.setEndDate() 
    }
    // Enable search button according to required fields
    searchEnable() {
        let { locationAllSelected } = this.state
        if(Boolean(this.state.search.locationid.value) || locationAllSelected) {
            if(this.state.DateCheckBoXValue && this.state.currentDate) {
                this.setState({
                    SearchButton: true
                })
            }
            else if(this.state.search.starttime.value && this.state.search.endtime.value) {
                this.setState({
                    SearchButton: true
                })
            } 
            else{
                this.setState({
                    SearchButton: false
                })
            }  
        }
        else {
            this.setState({
                SearchButton: false
            })
        }
    }
    /* called when search input changes */
    searchInputChange = (event) => {
        let eventValue = event.target.value;
        if(event.target.value==='all'){
            this.setState({
                ...this.state,
                issearch: true,
                isdisabled: true,
                search: {
                    ...this.state.search,
                    [event.target.name]: {
                        ...this.state.search[event.target.name],
                        value: eventValue
                    }
                }
            })
        }
        if(event.target.name === 'locationid'){
        this.setState({
            ...this.state,
            issearch: true,
            isdisabled: true,
            search: {
                ...this.state.search,
                [event.target.name]: {
                    ...this.state.search[event.target.name],
                    value: Number(eventValue)
                }
            }
        }, () => {
            if(event.target.value === 'All') {
                this.setState({
                    locationAllSelected: true
                },()=>{
                    this.searchEnable()
                }) 
            }
            else{
                this.setState({
                    locationAllSelected: false
                },()=>{
                    this.searchEnable()
                })
            }
            if(event.target.value === '')
            this.checkSearch();                
        });}
        else{
            this.setState({
                ...this.state,
                issearch: true,
                search: {
                    ...this.state.search,
                    [event.target.name]: {
                        ...this.state.search[event.target.name],
                        value: eventValue
                    }
                }
            }, () => {
                if (event.target.value === '')
                    this.checkSearch();
            });
        }
    }
    /* called when clear all in search clicked */
    resetState = () => {
        this.setState({
            ...this.state,
            search: this.initialSearchState,
            searchData: false,
            issearch: false,
            isdisabled: false,
            isActiveCheckbox: '',
            isDateFromCheckBox: false,
            DateCheckBoXValue: '',
            currentDate: '',
            locationAllSelected: false,
            SearchButton: false
        }, () => {
            this.dataTable.current.searchData();
        });
    }
    // handle enter key search
    _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.enableSearch()
        }
    }
    /* called when search button clicked */
    enableSearch = () => {
        var search = {
            starttime: { ...this.state.search.starttime, value: this.state.isDateFromCheckBox ? this.state.DateCheckBoXValue : this.state.search.starttime.value ? moment(new Date(this.state.search.starttime.value)).startOf('day').format("YYYY-MM-DD HH:mm:ss") : '' },
            endtime: { ...this.state.search.endtime, value: this.state.isDateFromCheckBox ? this.state.currentDate : this.state.search.endtime.value ? moment(new Date(this.state.search.endtime.value)).endOf('day').format("YYYY-MM-DD HH:mm:ss") : '' },
            locationid: { ...this.state.search.locationid, },
        }
        this.setState({
            filterSearch: search,
            searchData: true,
        }, () => {
            this.dataTable.current.searchData();
        });
    }
    /* check enable search and clear all */
    checkSearch = () => {
        let isenable = false;
        let issearchData = this.state.searchData;
        for (let control of Object.keys(this.state.search)) {
            if (this.state.search[control].value) {
                isenable = true;
                break;
            }
        }
        this.setState({
            ...this.state,
            search: isenable ? this.state.search : this.initialSearchState,
            searchData: isenable ? this.state.searchData : false,
            issearch: isenable
        }, () => {
            if (!isenable && issearchData)
                this.dataTable.current.searchData();
        });
    }
    updateTableData = (event) => {
        this.setState({
            ...this.state,
            tableData: event
        });
    }
    /* set date for date input change */
    setDate = (control, date) => {
        this.setState({
            ...this.state,
            issearch: true,
            search: {
                ...this.state.search,
                [control]: {
                    ...this.state.search[control],
                    value: date
                },
            }
        },() => {
            this.setState({
                ...this.state,
                isActiveCheckbox: '',
                isDateFromCheckBox: false,
                DateCheckBoXValue: '',
                currentDate: ""
            },()=>{
                this.searchEnable()
            })
        });
        }
    handleDateChangeRaw = (e) => {
        e.preventDefault();
    }
    /* Get Location list */
    getLocationList = async () => {
        await axios.all([
            await axios.post(getSellerUrl(locationlist), JSON.stringify({ field: ['id', 'title'] }), getSellerHeaders()),
        ])
           .then(response => {
                this.locations = response[0].data.data;
                if(this.locations.length == '1'){                
                        this.setState({
                            ...this.state,
                            locations: ArrayValueReorder(response[0].data.data, 'title'),
                            location: this.locations[0].title,
                            locationlength:this.locations.length,
                            isdisabled:true,
                            search: {
                                ...this.state.search,
                                locationid: {
                                    ...this.state.search.locationid,
                                    value: this.locations[0].id
                                },
                            }
                        });
                }
                else{
                        this.setState({
                            ...this.state,
                            locations: ArrayValueReorder(response[0].data.data, 'title'),
                            location: this.locations[0].title,
                            locationlength:this.locations.length,
                        })
                }
            })
            .catch(error => {
            });
    }
    render() {
        let date = new Date()
        let Yesterday = moment().subtract(1, "days").startOf('day').format("YYYY-MM-DD HH:mm:ss");
        let Year = moment().startOf('year').startOf('day').format("YYYY-MM-DD HH:mm:ss");
        let Month = moment().startOf('month').startOf('day').format("YYYY-MM-DD HH:mm:ss");
        let Week = moment(date).format('dddd') === 'Monday' ? moment().subtract(7, "days").startOf('day').format("YYYY-MM-DD HH:mm:ss") : moment().startOf('isoWeek').startOf('day').format("YYYY-MM-DD HH:mm:ss");
        let last_7days = moment().subtract(7, "days").startOf('day').format("YYYY-MM-DD HH:mm:ss");
        let last_30days = moment().subtract(30, "days").startOf('day').format("YYYY-MM-DD HH:mm:ss");
        let last_365days = moment().subtract(365, "days").startOf('day').format("YYYY-MM-DD HH:mm:ss");
        return (
            <div style={{ overflow: "auto", overflowY: "overlay" }} id="sale-hostory-report">
                <div className="sale-search">
                    <div className="sales-list-search">
                        <Form className="sales-list-font">
                            <div className="sales-search-container">
                                <Row>
                                <Col>
                                    <label>Location *</label>
                                        <Form.Control as="select" name="locationid" value={this.state.search.locationid.value} onKeyDown={this._handleKeyDown} onChange={(event) => this.searchInputChange(event)}>
                                           <option value="" disabled>Please select location</option>
                                            { this.state.locationlength > 1 ? <option value="All">All</option> : '' }
                                            {this.state.locations.map((loc, index) =>
                                                <option key={index} value={loc.id}>{loc.title}</option>
                                            )}
                                        </Form.Control>
                                    </Col>
                                    <Col>
                                        <label>Sale End Date From{!this.state.isActiveCheckbox ? "*" : ""}</label>
                                        <div>
                                            <label style={{ width: "100%" }} onClick={e => this.start.state.open && e.preventDefault()}>
                                                <DatePicker ref={r => this.start = r} className="datePicker" dateFormat="MM/dd/yyyy" value={this.state.search.starttime.value} selected={this.state.search.starttime.value} onChange={date => { this.setDate('starttime', date) }} onChangeRaw={this.handleDateChangeRaw} peekNextMonth showMonthDropdown showYearDropdown placeholderText="MM/DD/YYYY" dropdownMode="select" />
                                                <i style={{ position: "absolute", top: "52%", right: "12%", color: "#959393" }} className="fa fa-calendar" aria-hidden="true"></i>
                                            </label>
                                        </div>
                                    </Col>
                                    <Col>
                                        <label>Sale End Date To{!this.state.isActiveCheckbox ? "*" : ""}</label>
                                        <div>
                                            <label style={{ width: "100%" }} onClick={e => this.end.state.open && e.preventDefault()}>
                                                <DatePicker minDate={this.state.search.starttime.value ? this.state.search.starttime.value : ''} ref={r => this.end = r} className="datePicker" dateFormat="MM/dd/yyyy" value={this.state.search.endtime.value} selected={this.state.search.endtime.value} onChange={date => { this.setDate('endtime', date) }} onChangeRaw={this.handleDateChangeRaw} peekNextMonth showMonthDropdown showYearDropdown placeholderText="MM/DD/YYYY" dropdownMode="select" />
                                                <i style={{ position: "absolute", top: "52%", right: "12%", color: "#959393" }} className="fa fa-calendar" aria-hidden="true"></i>
                                            </label>
                                        </div>
                                    </Col>   
                                    <Col>
                                        <div className="mt-3">
                                            <Button className="clear-button" onClick={() => this.resetState()}>Clear All</Button>
                                            <Button variant="search-button" disabled={!this.state.SearchButton} onClick={() => this.enableSearch()}>Search</Button>
                                        </div>
                                    </Col>                      
                                </Row>
                                <Row style={{ width: '70%'}}>
                                    <Col>
                                        <div className={`d-flex align-items-center header`}>
                                            <div style={{ marginLeft: '10px' }}>
                                                 <div className={`custom-checkbox-div ${this.state.isActiveCheckbox === 'yesterday'? 'checked' : ''}`} onClick={() => this.onChangeCheckBox('yesterday',Yesterday)}></div>
                                             </div>
                                            <div style={{ marginLeft: '5%'}}>
                                                 <div>Yesterday</div>
                                            </div>
                                            <div style={{ marginLeft: '4%', marginTop: '1.5px'}}>
                                               <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'Yesterday'}</Tooltip>}>
                                                     <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i> 
                                                </OverlayTrigger>
                                            </div>
                                        </div>
                                   </Col>
                                   <Col>
                                        <div className={`d-flex align-items-center header`}>
                                            <div style={{ marginLeft: '10px'}}>
                                               <div className={`custom-checkbox-div ${this.state.isActiveCheckbox === 'week' ? 'checked' : ''}`} onClick={() => this.onChangeCheckBox('week',Week)}></div>
                                            </div>
                                            <div style={{ marginLeft: '5%'}}>
                                                <div>Week to Date</div>
                                            </div>
                                            <div style={{ marginLeft: '4%', marginTop: '1.5px'}}>
                                               <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'Monday to today of current week'}</Tooltip>}>
                                                     <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i> 
                                                </OverlayTrigger>
                                            </div>
                                        </div>
                                   </Col>
                                   <Col>
                                        <div className={`d-flex align-items-center header`}>
                                            <div style={{ marginLeft: '10px'}}>
                                                <div className={`custom-checkbox-div ${this.state.isActiveCheckbox === 'month'? 'checked' : ''}`} onClick={() => this.onChangeCheckBox('month',Month)}></div>
                                            </div>
                                            <div style={{ marginLeft: '5%'}}>
                                                 <div>Month to Date</div>
                                            </div>
                                            <div style={{ marginLeft: '4%', marginTop: '1.5px'}}>
                                               <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'First day of the current month to current date'}</Tooltip>}>
                                                     <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i> 
                                                </OverlayTrigger>
                                            </div>
                                        </div>
                                   </Col>
                                   <Col>
                                        <div className={`d-flex align-items-center header`}>
                                            <div style={{ marginLeft: '10px'}}>
                                               <div className={`custom-checkbox-div ${this.state.isActiveCheckbox === 'year'? 'checked' : ''}`} onClick={() => this.onChangeCheckBox('year',Year)}></div>
                                            </div>
                                            <div style={{ marginLeft: '5%'}}>
                                                 <div>Year to Date</div>
                                            </div>
                                            <div style={{ marginLeft: '4%', marginTop: '1.5px'}}>
                                               <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'First day of the current year to current date'}</Tooltip>}>
                                                     <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i> 
                                                </OverlayTrigger>
                                            </div>
                                        </div>
                                   </Col>
                                </Row>
                                <Row style={{ width: '70%'}}>
                                    <Col>
                                        <div className={`d-flex align-items-center header`}>
                                            <div style={{ marginLeft: '10px' }}>
                                                <div className={`custom-checkbox-div ${this.state.isActiveCheckbox === 'last_7days'? 'checked' : ''}`} onClick={() => this.onChangeCheckBox('last_7days',last_7days)}></div>
                                            </div>
                                            <div style={{ marginLeft: '5%'}}>
                                                <div>Last 7 days</div>
                                            </div>
                                            <div style={{ marginLeft: '4%', marginTop: '1.5px'}}>
                                               <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'Past 7 days excluding current date'}</Tooltip>}>
                                                     <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i> 
                                                </OverlayTrigger>
                                            </div>
                                        </div>
                                   </Col>
                                   <Col>
                                        <div className={`d-flex align-items-center header`}>
                                            <div style={{ marginLeft: '10px'}}>
                                              <div className={`custom-checkbox-div ${this.state.isActiveCheckbox === 'last_30days'? 'checked' : ''}`} onClick={() => this.onChangeCheckBox('last_30days',last_30days)}></div>
                                            </div>
                                            <div style={{ marginLeft: '5%'}}>
                                                <div>Last 30 days</div>
                                            </div>
                                            <div style={{ marginLeft: '4%', marginTop: '1.5px'}}>
                                               <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'Past 30 days excluding current date'}</Tooltip>}>
                                                     <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i> 
                                                </OverlayTrigger>
                                            </div>
                                        </div>
                                   </Col>
                                   <Col>
                                        <div className={`d-flex align-items-center header`}>
                                            <div style={{ marginLeft: '10px'}}>
                                                <div className={`custom-checkbox-div ${this.state.isActiveCheckbox === 'last_365days'? 'checked' : ''}`} onClick={() => this.onChangeCheckBox('last_365days',last_365days)}></div>
                                            </div>
                                            <div style={{ marginLeft: '5%'}}>
                                                <div>Last 365 days</div>
                                            </div>
                                            <div style={{ marginLeft: '4%', marginTop: '1.5px'}}>
                                               <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'Past 365 days excluding current date'}</Tooltip>}>
                                                     <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i> 
                                                </OverlayTrigger>
                                            </div>
                                        </div>
                                   </Col>
                                   <Col>
                                   </Col>
                                </Row>
                            </div>
                        </Form>
                    </div>
                </div>
                <div className="sale-list">
                    <Datatable config={{ ...this.config }} search={this.state.searchData ? { search: { ...this.state.filterSearch }, searchData: this.state.searchData } : null} ref={this.dataTable} onDataUpdate={this.updateTableData}></Datatable>
                </div>
            </div>
        );
    }
}

